import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/preProductionDashboard.css';
import Nav from '../components/nav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const PreProductionDashboard = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <>
      <SEO
        title="Pre-Production Dashboard"
        description="Manage your film's pre-production phase — script development, casting, budgeting, and scheduling — all in one dashboard on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/pre-production"
        robots="noindex, nofollow"
      />
      <Nav />
      <div className="pre-dashboard-container">
        <main id="preProduction">
          <NavLink to="/howto">
            <button id="backButton" className="glass-button">
              <span>←</span> Back
            </button>
          </NavLink>
          
          <div id="dashboardTitle" className={`fade-in ${isLoaded ? 'visible' : ''}`}>
            <h1>Pre-Production Dashboard (How to use these AI Tools)</h1>
            <div className="welcome-message">
              <span className="wave">👋</span>
              <p id="welcomeMessage">Welcome back!</p>
            </div>
          </div>

          <div id="preProdMainCardWrapper">
            <NavLink to="/SAHowTo" className="card-link">
              <div className="pre-dashboard-card script-analysis">
                <div className="card-content">
                  <div className="icon-wrapper">
                    <svg viewBox="0 0 24 24" className="card-icon">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <polyline points="14 2 14 8 20 8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <polyline points="10 9 9 9 8 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    </svg>
                  </div>
                  <h1>Script Analysis</h1>
                  <p className="card-description">Analyze and break down your script with AI assistance</p>
                </div>
                <div className="card-backdrop"></div>
              </div>
            </NavLink>

            <NavLink to="/castHowTo" className="card-link">
              <div className="pre-dashboard-card casting">
                <div className="card-content">
                  <div className="icon-wrapper">
                    <svg viewBox="0 0 24 24" className="card-icon">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <circle cx="9" cy="7" r="4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    </svg>
                  </div>
                  <h1>Casting Assistant</h1>
                  <p className="card-description">Manage your casting process with AI tools</p>
                </div>
                <div className="card-backdrop"></div>
              </div>
            </NavLink>

            <NavLink to="/budgetHowTo" className="card-link">
              <div className="pre-dashboard-card budgeting">
                <div className="card-content">
                  <div className="icon-wrapper">
                    <svg viewBox="0 0 24 24" className="card-icon">
                      <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    </svg>
                  </div>
                  <h1>Budgeting</h1>
                  <p className="card-description">Plan and track your budget with AI insights</p>
                </div>
                <div className="card-backdrop"></div>
              </div>
            </NavLink>

            <NavLink to="/locationHowTo" className="card-link">
              <div className="pre-dashboard-card locations">
                <div className="card-content">
                  <div className="icon-wrapper">
                    <svg viewBox="0 0 24 24" className="card-icon">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                      <circle cx="12" cy="10" r="3" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                    </svg>
                  </div>
                  <h1>Locations</h1>
                  <p className="card-description">Scout and manage locations with AI recommendations</p>
                </div>
                <div className="card-backdrop"></div>
              </div>
            </NavLink>
          </div>
        </main>
      </div>
    </>
  );
};

export default PreProductionDashboard;
